let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("gwV0J"), load("3t6fF"), load("6wr18"), load("37ldp"), load("ffEVr"), load("hhss7"), load("aDFb6")]).then(() => parcelRequire('2zBDm'));